// Components==============
import sendEmail from 'actions/mail/send';
import Button from 'components/UI/Button';
import { TextAreaInput, TextInput } from 'components/UI/Form/Input';
import Modal from 'components/UI/Modal';
import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { GlobalContext } from 'utilities/GlobalContextWrapper';
import { useCloseUrlModal } from 'utilities/useCloseUrlModal';
import { useFormValues } from 'utilities/useFormValues';
import './index.module.scss';
// =========================

export default function ContactModal() {
    const { contactText } = useContext(GlobalContext);
    const [displayMessage, setDisplayMessage] = useState('');
    const [mailConfirm, setMailConfirm] = useState('');

    const { formValues, handleChange } = useFormValues(
        {
            name: '',
            mail: '',
            subject: '',
            question: '',
        },
        () => setDisplayMessage('')
    );

    const dispatch = useDispatch();
    const closeUrlModal = useCloseUrlModal();

    const { name, mail, subject, question } = formValues;

    function handleSubmit(e) {
        e.preventDefault();
        if (mail !== mailConfirm)
            return setDisplayMessage('De email adressen komen niet overeen');

        dispatch(
            sendEmail({
                ...formValues,
                type: contactText.type,
            })
        ).then(() => {
            closeUrlModal();
        });
    }

    return (
        <Modal slug="contact-popup">
            <div styleName="content">
                <h2>{contactText.title}</h2>
                <p styleName="text">{contactText.text}</p>
                <form onSubmit={handleSubmit}>
                    <TextInput
                        label="Naam *"
                        name="name"
                        value={name}
                        onChange={handleChange}
                    />
                    <TextInput
                        label="E-mailadres *"
                        name="mail"
                        type="email"
                        value={mail}
                        onChange={handleChange}
                    />
                    <TextInput
                        label="E-mailadres bevestiging *"
                        name="mailConfirm"
                        type="email"
                        value={mailConfirm}
                        onChange={(e) => {
                            setDisplayMessage('');
                            setMailConfirm(e.target.value);
                        }}
                    />
                    <TextInput
                        label="Onderwerp"
                        name="subject"
                        value={subject}
                        onChange={handleChange}
                        required={false}
                    />
                    <TextAreaInput
                        label="Vraag *"
                        name="question"
                        value={question}
                        onChange={handleChange}
                    />
                    <Button>Verzenden</Button>
                </form>
                {displayMessage && <p styleName="error">{displayMessage}</p>}
            </div>
        </Modal>
    );
}
